import type React from 'react'

import UploadIcon from '@/assets/images/file-upload-drop.svg?react'
import css from './FileDropZone.module.scss'

export const DropTarget: React.FC = () => (
  <div className={css.dropTarget}>
    <UploadIcon />
  </div>
)
